import styled from "styled-components";
import { theme } from "@themes";

export const ContainerBack = styled.div`
  display: grid;
  grid-template-columns: 27vw 1fr;
  background-color: ${({ bgBack }) => (bgBack ? bgBack : "inherit")};
`;

const handleColumnWidth = (props) => {
  switch (props) {
    case "isMoodMeterSettings":
      return "7vw 6vw 1fr 1fr";
    case "isMyCoaches":
      return "7vw 5vw 1fr 1fr";
    case "createSpace":
      return "7vw 10.5vw 1fr 1fr";
    case "createGame":
      return "7vw 9.5vw 1fr 1fr";
    case "surveyReports":
      return "7vw 11vw 1fr 1fr";
    case "UserManagementDownload":
      return "7vw 7vw 1fr 1fr";
    case "createUpdateLob":
      return "7vw 9vw 3vw 1fr";
    case "createUpdatePolicy":
      return "7vw 4vw 1fr 1fr";
    case "instantMessages":
      return "7vw 10vw 2fr 1fr";
    default:
      return "7vw 8vw 1fr 1fr";
  }
};

export const ContentBack = styled.div`
  display: grid;
  grid-template-columns: 7vw 8.2vw 12vw 1fr;
  align-items: center;
  @media only screen and (min-width: 769px) {
    grid-template-columns: ${({ props }) => handleColumnWidth(props)};
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 13vw 13vw 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 25vw 25vw 1fr;
  }
`;

export const ButtonBack = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 60%;
  height: 25px;
  margin: 0px auto;
  margin-left: ${({ applyMargin }) => (applyMargin ? "0 !important" : "")};
  margin-right: ${({ applyMargin }) => (applyMargin ? "0 !important" : "")};
  text-align: left;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
